/**
 * src/data/templateImages.js — ảnh cover cho từng mẫu Excel.
 *
 * Ảnh nằm trong public/ nên đường dẫn cố định theo slug của mẫu; danh sách dưới
 * đây để biết mẫu nào đã có ảnh, tránh chèn thẻ <img> trỏ vào file không tồn tại.
 * Ảnh do design/thuat-ngu/mau-cover.js sinh ra: khung bảng tính mô phỏng đúng
 * nội dung của mẫu, mọi con số đều là ví dụ.
 */
export const CO_ANH_MAU = new Set([
  'bo-ho-so-tham-dinh-data-room',
  'cap-table-pha-loang-safe',
  'dinh-gia-startup-dcf',
  'mo-hinh-tai-chinh-36-thang-saas',
  'mo-hinh-tai-chinh-chuoi-fnb',
  'mo-hinh-tai-chinh-saas',
  'mo-hinh-tai-chinh-thuong-mai-dien-tu',
  'theo-doi-tiep-can-nha-dau-tu',
  'so-sanh-term-sheet',
]);

/** Ảnh hiển thị đầu trang mẫu (1600×900, WebP). */
export const anhMau = (slug) => (CO_ANH_MAU.has(slug) ? `/anh/mau/${slug}.webp` : '');
/** Ảnh chia sẻ Facebook/Zalo (1200×630, JPEG). */
export const anhChiaSeMau = (slug) => (CO_ANH_MAU.has(slug) ? `/og/mau/${slug}.jpg` : '');
